/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../../extendIcon';

const SubUnits = props => (
  <svg viewBox="0 0 31 32" width="1em" height="1em" {...props}>
    <path
      d="M29.345 30.27V14.13h.94v-1.978H20.64V3.806h1.152L20.77 1.342h-2.304V.034H3.361v1.308H1.057L.033 3.806h1.152V30.27H.1v1.696h30.33V30.27h-1.085zM7.073 28.056h-2.56v-5.12h2.56v5.12zm0-7.68h-2.56v-5.12h2.56v5.12zm0-7.68h-2.56v-5.12h2.56v5.12zm5.12 15.36h-2.56v-5.12h2.56v5.12zm0-7.68h-2.56v-5.12h2.56v5.12zm0-7.68h-2.56v-5.12h2.56v5.12zm5.12 15.36h-2.56v-5.12h2.56v5.12zm0-7.68h-2.56v-5.12h2.56v5.12zm0-7.68h-2.56v-5.12h2.56v5.12zm5.12 15.36H20.28v-2.154h2.154v2.154zm0-4.202H20.28V21.7h2.154v2.154zm0-4.202H20.28v-2.154h2.154v2.154zm4.202 8.404h-2.154v-2.154h2.154v2.154zm0-4.202h-2.154V21.7h2.154v2.154zm0-4.202h-2.154v-2.154h2.154v2.154z"
      fill="#231F20"
      fillRule="evenodd"
    />
  </svg>
);
export default extendIcon(SubUnits);
